import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueSession from 'vue-session'
import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'
import VueDragResize from 'vue-drag-resize'
import i18n from '@/libs/i18n'
import VueExcelXlsx from 'vue-excel-xlsx'
import router from './router'
import store from './store'
import App from './App.vue'
// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'

// BSV Plugin Registration
Vue.use(Croppa)
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueSession)
Vue.use(VueExcelXlsx)

// Composition API
Vue.use(VueCompositionAPI)
Vue.component('vue-drag-resize', VueDragResize)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
